export const formatPhoneNumber = (value = '') => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 10);
  const parts = [];

  if (digits.length >= 1) {
    const area = digits.slice(0, 3);
    const hasArea = area.length === 3;
    const areaLabel = hasArea ? `(${area})` : `(${area}`;
    parts.push(areaLabel);
  }
  if (digits.length >= 4) {
    const middle = digits.slice(3, 6);
    if (middle) {
      parts.push(`${middle}`);
    }
  }
  if (digits.length > 6) {
    const last = digits.slice(6, 10);
    parts.push(last);
  }

  if (parts.length === 0) {
    return '';
  }

  if (parts.length === 1) {
    return `${parts[0]}`;
  }
  if (parts.length === 2) {
    return `${parts[0]}- ${parts[1]}`;
  }
  return `${parts[0]}- ${parts[1]}-${parts[2]}`;
};

export default formatPhoneNumber;
